export const CRITICAL_RESOURCES = {
  dropdownValues: { field: 'DropdownValues', apiKey: 'dropdownValues' },
  hoverDescriptions: { field: 'HoverDescriptions', apiKey: 'hoverDescriptions' },
  globalVariables: { field: 'GlobalVariables', apiKey: 'globalVariables' },
  tbdAudit: { field: 'TBDAudit', apiKey: 'tbdValues' },
  holidays: { field: 'Holidays', apiKey: 'holidays' },
  userPreferences: { field: 'UserPreferences', apiKey: 'userPreferences' },
  iconData: { field: 'IconData', apiKey: 'iconData' },
};
export const criticalDataArgs = state => ({
  url: state.apiUrls?.urls?.criticalData || '/critical-data',
  accountId: state.user?.userDetails?.localAccountId || state.user?.userDetails?.username || '',
  session: state.criticalData?.session || 0,
});
export const criticalDataScope = state => JSON.stringify(criticalDataArgs(state));
